import { createRouter, createWebHistory } from 'vue-router'

import HomeView from './pages/home';
import ProtocolView from './pages/protocol';
import PlantemplateView from './pages/plantemplate';

const routes = [
  { path: '/', redirect: 'home' },
  { path: '/home', name: 'home', component: HomeView },
  { path: '/protocol/:target', name: 'protocol', component: ProtocolView },
  { path: '/plan/template/detail', name: 'plantemplate', component: PlantemplateView }
]

export default createRouter({
  history: createWebHistory(),
  routes,
})
